// ─── Hook clavier (Core) ─────────────────────────────────────────
// `useClavierVisible()` → booléen : le clavier logiciel est-il affiché ?
// Sert à montrer un bouton ⌨️ « réduire le clavier » quand il est ouvert.
// Sur le web (clavier physique), reste toujours false → pas de bouton.
import { useEffect, useState } from 'react';
import { Keyboard, Platform } from 'react-native';

export function useClavierVisible() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (Platform.OS === 'web') return undefined;
    const evShow = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
    const evHide = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';
    const s1 = Keyboard.addListener(evShow, () => setVisible(true));
    const s2 = Keyboard.addListener(evHide, () => setVisible(false));
    return () => { s1.remove(); s2.remove(); };
  }, []);
  return visible;
}

export const reduireClavier = () => Keyboard.dismiss();
